
// Factor to convert minutes to pixels (height in pixels per minute)
export const factorHeightDuration = 3.735; // 1 minute = 3.735 px

// Constants for the route timeline (hours from 09:00 to 24:00)
export const dailyHours = Array.from({ length: 24 - 9 + 1 }, (_, i) => {
  const hour = i + 9;
  return (hour === 24 ? '00' : hour.toString().padStart(2, '0'));
});

// Constants for updating the route timeline (09:00 to 24:00 every 15 minutes)
export const intervalMinutes = 15; 
export const startHour = 9;
export const endHour = 24;